export default "__VITE_ASSET__7s1vY$7b__"